module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (this.records > this.numberPerPage) ? _c('ul', {
    staticClass: "tabs cc-pills",
    attrs: {
      "id": "pagination"
    }
  }, [_c('li', {
    class: [{
      disabled: !_vm.showLeft
    }],
    on: {
      "click": _vm.goFirst
    }
  }, [_c('a', [_vm._v("<<")])]), _vm._v(" "), _c('li', {
    class: [{
      disabled: !_vm.showLeft
    }],
    on: {
      "click": _vm.goPrev
    }
  }, [_c('a', [_vm._v("<")])]), _vm._v(" "), _vm._l((_vm.pagination), function(item, index) {
    return _c('li', {
      class: {
        active: item.active, disabled: item.disabled
      }
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.changePage(index)
        }
      }
    }, [_vm._v("\n            " + _vm._s(item.text) + "\n        ")])])
  }), _vm._v(" "), _c('li', {
    class: [{
      disabled: !_vm.showRight
    }],
    on: {
      "click": _vm.goNext
    }
  }, [_c('a', [_vm._v(">")])]), _vm._v(" "), _c('li', {
    class: [{
      disabled: !_vm.showRight
    }],
    on: {
      "click": _vm.goLast
    }
  }, [_c('a', [_vm._v(">>")])])], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8c2eda84!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/pagination.vue
// module id = 232
// module chunks = 0